import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// File should be "index.js" but with the current build process we will make sure the name is distinguishable.

const elements = document.querySelectorAll('.post-filters-archive');

elements.forEach((element) => {
	const root = createRoot(element);

	const settings = {
		apiBase: element.getAttribute('data-api-base'),
		postType: element.getAttribute('data-post-type') ?? 'post',
		postsPerPage: element.getAttribute('data-posts-per-page') ?? 12,
		hideImages: element.getAttribute('data-hide-images') ?? false,
		filtersToShow: element.getAttribute('data-filters-to-show')?.length
			? element.getAttribute('data-filters-to-show').split(',')
			: [],
		showSearch: element.getAttribute('data-show-search'),
		layout: element.getAttribute('data-layout'),
		searchTitle: element.getAttribute('data-search-title') ?? 'Search by keyword',
		initSelectedTax: element.getAttribute('data-selected-tax')
			? JSON.parse(element.getAttribute('data-selected-tax'))
			: {},
	};

	if (settings.apiBase.length) {
		root.render(
			<React.StrictMode>
				<App settings={settings} />
			</React.StrictMode>
		);
	}
});
